import React, {memo} from "react";
import PropTypes from "prop-types";
import ForwardRef from "../../../hoc/ForwardRef";
import AnchorPWA from "./widgets/AnchorPWA";
import AnchorNonPWA from "./widgets/AnchorNonPWA";
import routes from "../../../Routes/routes";
import {matchPath} from "react-router";
import {useSelector} from "react-redux";
import config from "../../../config/config";
const AnchorWrapper = (props) => {
    const {isPWALink, linkHref} = props;
    let overrideLinkHref = linkHref;
    if (linkHref.includes("/")) {
        if (isPWALink && !linkHref.includes("/studyabroad/")) {
            overrideLinkHref = `${config.SHIKSHA_STUDYABROAD_BASENAME}${linkHref}`;
        } else {
            // true if url is relative
            const relativeRegex = /^(https?|ftp):\/\//i;
            if (!relativeRegex.test(linkHref) && !linkHref.includes("/studyabroad/")) {
                overrideLinkHref = `${config.SHIKSHA_STUDYABROAD_BASENAME}${linkHref}`;
            }
        }
    }
    return <Anchor {...props} linkHref={overrideLinkHref} />;
};
const Anchor = (props) => {
    const {children, isPWALink, debug} = props;
    const isUserLoggedIn = useSelector(
        (state) => state.layout?.userAndShortlistData?.userLoggedIn ?? false,
    );

    if (isPWALink === true) {
        return (
            <AnchorPWA {...props} isPWALink={isPWALink} isUserLoggedIn={isUserLoggedIn}>
                {children}
            </AnchorPWA>
        );
    } else {
        //check url is pwa or not
        const activeRoute = routes.find((route) => matchPath(props.linkHref, route));
        if (activeRoute.componentName !== "Page404") {
            return (
                <AnchorPWA {...props} isPWALink={true} isUserLoggedIn={isUserLoggedIn}>
                    {children}
                </AnchorPWA>
            );
        }

        if (debug) {
            console.log("AMAN", props);
        }

        return (
            <AnchorNonPWA {...props} isPWALink={isPWALink} isUserLoggedIn={isUserLoggedIn}>
                {children}
            </AnchorNonPWA>
        );
    }
};
Anchor.propTypes = {
    children: PropTypes.node,
    isPWALink: PropTypes.bool,
    linkHref: PropTypes.string,
    target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
    title: PropTypes.string,
    linkLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    showLinkIcon: PropTypes.bool,
    displayStyle: PropTypes.object,
    preventDefault: PropTypes.bool,
    active: PropTypes.bool,
    debug: PropTypes.bool,
    onClickHandle: PropTypes.func,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    enableRipple: PropTypes.bool,
    linkType: PropTypes.bool,
    after: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    forwardRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.instanceOf(
                typeof Element === "undefined" ? function () {} : Element,
            ),
        }),
    ]),
    customClassName: PropTypes.string,
    rippleDuration: PropTypes.number,
};
Anchor.defaultProps = {
    isPWALink: false,
    rippleDuration: 500,
    linkHref: "#",
    target: "_blank",
    title: "",
    showLinkIcon: false,
    preventDefault: false,
    debug: false,
    disabledExternalValidation: false,
};

AnchorWrapper.propTypes = Anchor.propTypes;
AnchorWrapper.defaultProps = Anchor.defaultProps;

export default memo(ForwardRef(AnchorWrapper));
